import { useState } from 'react';
import { CheckCircle2, RefreshCw } from 'lucide-react';
import { Topbar } from '@/components/layout/Topbar';
import {
  useDeclarationsSoumises,
  useValiderDeclaration,
} from '@/hooks/useTerrainAdmin';
import { DeclarationValidationCard, RenvoyerDeclarationDialog } from './DeclarationValidationCard';

/**
 * SIMG-TERRAIN-2026-001 — Page "Validations" du back-office terrain.
 *
 * Les déclarations soumises apparaissent aussi dans « Validations en attente »,
 * avec les proformas et les bons de commande : c'est là que le DAF travaille.
 * Cette page reste l'entrée du back-office terrain, pour qui veut ne regarder
 * que les chantiers. Les deux affichent la même carte.
 */

export const ValidationsPage = () => {
  const { data: decls = [], isLoading, refetch, isFetching } = useDeclarationsSoumises();
  const valider = useValiderDeclaration();
  const [showRenvoyer, setShowRenvoyer] = useState<any | null>(null);

  return (
    <>
      <Topbar
        title="Déclarations du terrain"
        subtitle="Vue chantier seule — elles figurent aussi dans « Validations en attente »"
        actions={
          <button className="ds-btn ds-btn-g ds-btn-sm" onClick={() => void refetch()} title="Rafraîchir">
            <RefreshCw size={14} className={isFetching ? 'animate-spin' : ''} />
          </button>
        }
      />
      <div className="ds-content">
        {isLoading && <div style={{ padding: 24, textAlign: 'center', color: 'var(--tx-3)' }}>Chargement…</div>}

        {!isLoading && decls.length === 0 && (
          <div className="ds-panel" style={{ padding: 32, textAlign: 'center' }}>
            <CheckCircle2 size={40} style={{ color: 'var(--ok-1)', marginBottom: 8 }} />
            <p style={{ color: 'var(--tx-2)', margin: 0 }}>Aucune déclaration en attente de validation.</p>
          </div>
        )}

        {decls.length > 0 && (
          <div style={{ display: 'grid', gap: 12 }}>
            {decls.map((d: any) => (
              <DeclarationValidationCard
                key={d.id}
                declaration={d}
                onValider={() => valider.mutate(d.id)}
                onRenvoyer={() => setShowRenvoyer(d)}
                pending={valider.isPending}
              />
            ))}
          </div>
        )}
      </div>

      {showRenvoyer && (
        <RenvoyerDeclarationDialog
          declaration={showRenvoyer}
          onClose={() => setShowRenvoyer(null)}
          onDone={() => setShowRenvoyer(null)}
        />
      )}
    </>
  );
};

// ─── Card d'une déclaration ────────────────────────────────────

// ─── Dialog renvoi avec motif ──────────────────────────────────
